import React from 'react';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

import { userRoles, categories } from 'util/appConstants';
import { Checkbox } from 'components/Checkbox/Checkbox';
import { useAppContext, useFreecodeContext } from 'hooks/useContext';
import FreecodeVersioning from './FreecodeVersioning';
import FreecodeTestCases from './FreecodeTestCases';
import {
  FreecodeTabContentContainer,
  Title,
  RowContainer,
  ColumnContainer,
  FormSection,
  NumberInput,
  Label,
  InputContainer,
} from '../../styles';

export default function FreecodeSettings() {
  const { isDarkMode } = useAppContext();
  const { test, testImpl } = useFreecodeContext();

  const { userRole } = useSelector((state) => state.auth);

  return (
    <FreecodeTabContentContainer isDarkMode={isDarkMode}>
      <RowContainer>
        <ColumnContainer>
          <FreecodeTestCases />
          {userRole === userRoles.SUPER_ADMIN && (
            <FormSection>
              <Title>Custom Timeout</Title>
              <Label>
                Strongly discurraged. There is no indicator that the solution is still alive, large values might lead to
                user confusion and dead workloads.
              </Label>
              <Checkbox
                isDarkMode={isDarkMode}
                checked={!!testImpl.configLevels.solutionTimeout}
                label="I know what I am doing"
                onChange={() => toast.error('Not Implemented')} // TODO Implement
              />
              {!!testImpl.configLevels.solutionTimeout && (
                <InputContainer>
                  <Label nowrap>Seconds per level:</Label>
                  <NumberInput
                    value={testImpl.configLevels.solutionTimeout}
                    onChange={() => toast.error('Not Implemented')} // TODO Implement
                  ></NumberInput>
                </InputContainer>
              )}
            </FormSection>
          )}
        </ColumnContainer>
        <ColumnContainer>
          <FormSection>
            <Title>Executor</Title>
            <InputContainer>
              <Label nowrap>Executor version:</Label>
              <NumberInput disabled value={testImpl.executionVersion}></NumberInput>
            </InputContainer>
          </FormSection>
          {test.category !== categories.CODE.category && (
            <FormSection>
              <Title>Community</Title>
              <Label>Public implementations and solutions can be inspected and coppied by other users</Label>
              <InputContainer>
                <Checkbox
                  isDarkMode={isDarkMode}
                  checked={test.publicToCommunity}
                  title="The implementation will be public so others can inspect it and create new ones with the code as a base"
                  label="Public Implementation"
                  onChange={() => toast.error('Not Implemented')} // TODO Implement
                />
              </InputContainer>
              <InputContainer>
                <Checkbox
                  isDarkMode={isDarkMode}
                  checked={test.publicToCommunitySolution}
                  title="The creator solution will be public so others can inspect how it is intended to be solved (note: can be used to cheat)"
                  label="Public Solution"
                  onChange={() => toast.error('Not Implemented')} // TODO Implement
                />
              </InputContainer>
            </FormSection>
          )}
          <FreecodeVersioning />
        </ColumnContainer>
      </RowContainer>
    </FreecodeTabContentContainer>
  );
}
